import React from "react";
import App from "./App";
import useAuthFocusSync from "./hook/useAuthFocusSync";
import useAuthGlobalListener from "./hook/useAuthGlobalListener";
import { Card, ConfigProvider, theme } from "antd";
import { connect } from "react-redux";
// import "antd/dist/antd.css";
// import useAuthFocusSync from "./hooks/useAuthFocusSync";

// const App = React.lazy(() => import(/* webpackPrefetch: true */ "./App"));

function AppWrapper(props) {
  const { history, users } = props;
  const isPaymentPage =
    history?.location?.pathname &&
    String(history?.location?.pathname).includes("/payment/");

  // console.log(users)

  const authEnabled = !isPaymentPage && users?.isAuthenticated === true;

  useAuthGlobalListener(authEnabled);
  useAuthFocusSync(authEnabled);

  return (
    <ConfigProvider
      theme={{
        hashed: false,
        algorithm: theme.defaultAlgorithm,
        token: {
          zeroRuntime: true,
          colorPrimary: "#0F766E",
          colorSuccess: "#16A34A",
          colorWarning: "#F59E0B",
          colorError: "#DC2626",
          colorInfo: "#2563EB",
          colorBgLayout: "#F5F7FA",
          colorBgContainer: "#FFFFFF",
          colorBorder: "#E5E7EB",
          colorText: "#111827",
          colorTextSecondary: "#6B7280",
          fontSize: 14,
        },
        components: {
          Button: {
            boxShadow: "none",
            // Primary button
            colorPrimary: "#0F766E",
            colorPrimaryHover: "#0D6B64",
            colorPrimaryActive: "#0A5F58",
            // Default button
            colorDefault: "#6B7280",
            colorDefaultHover: "#4B5563",
            // Box shadow
            boxShadow: "none",
            boxShadowHover: "none",
          },
          // ============ MODAL ============
          Modal: {
            // Header
            colorBgHeader: "#FFFFFF",
            colorTextHeader: "#111827",

            // Footer
            colorBgFooter: "#F9FAFB",

            // Border radius
            borderRadius: 12,
            borderRadiusLG: 12,
          },
          Card: {
            headerBg: "#0F766E",
            headerFontSize: 15,
            bodyPadding: "10px",
            headerHeight: 44,
            headerPadding: 16,
            extraColor: "red",
          },
        },
      }}
    >
      <App {...props} />
    </ConfigProvider>
  );
}

const mapStateToProps = (state) => ({
  users: state.authentication,
});

export default connect(mapStateToProps)(AppWrapper);
